import type { PocDateType } from 'commons/types';
import { DateRangeDatePicker } from './date-range-filter.style';
import { useDateRangeFilter } from './use-date-range-filter.hook';

interface DateRangeFilterProps {
    name: string;
    placeholder: string;
    appliedFrom?: PocDateType;
    appliedTo?: PocDateType;
    onApplyRange: (from?: PocDateType, to?: PocDateType) => void;
}

export const DateRangeFilter: React.FC<DateRangeFilterProps> = ({
    name,
    placeholder,
    appliedFrom,
    appliedTo,
    onApplyRange,
}) => {
    const { value, secondaryValue, isApplyDisabled, handleChange, handleApply, handleClear } = useDateRangeFilter({
        appliedFrom,
        appliedTo,
        onApplyRange,
    });

    return (
        <DateRangeDatePicker
            name={name}
            isFilter
            nonEditableInput
            datePickerType="range"
            autoClose={false}
            applyDisabled={isApplyDisabled}
            value={value}
            secondaryValue={secondaryValue}
            placeholder={placeholder}
            onChange={handleChange}
            onApply={handleApply}
            onClear={handleClear}
        />
    );
};
